module.exports = __webpack_public_path__ + "media/images/countryrect/gu-0cdae716daecf832e2710a13e8a08cfd.svg";